'use strict';

import {subscribe} from '../helpers/pubSub';
import {handleCartAdd} from './addToCart';
import {updateHistoryState, appendParamsToURL, getQueryStringParams} from '../helpers/urlUtilities';
import {widget3DConfiguration} from './widget3D';
import {setupAJAXForm} from '../modules/module.ajax-form';
import modules from '../helpers/modules';
import {initShareLink, getProductContainer, chooseColorBackToPdp} from './productUtils';
import * as dialog from '../components/dialog';
import {validateForm} from '../components/clientSideValidation';


function personalisationInit(productData, productContainer, vasType) {
    let isPersonalisationEnabled = false;
    if (productData.isPersonalisationEnabled) {
        if (vasType == 'engrav') {
            isPersonalisationEnabled = productData.isEngrav;
        } else if (vasType == 'emboss') {
            isPersonalisationEnabled = productData.isEmbossed;
        } else if (vasType == 'bracelet-adjustment') {
            isPersonalisationEnabled = productData.isBraceletAdjustable;
        }
    }

    [].forEach.call(productContainer.querySelectorAll('[data-product-component="show-' + vasType + '-form"]'), function(currentEl) {
        if (isPersonalisationEnabled) {
            $(currentEl).removeClass('disable--personalisation');
            if (vasType == 'engrav') {
                personalisationModal.initEngravBtn();
            } else if (vasType == 'emboss') {
                personalisationModal.initEmbossBtn();
            } else if (vasType == 'bracelet-adjustment') {
                personalisationModal.initBraceletAdjustmentBtn();
            }
        } else {
            $(currentEl).off().addClass('disable--personalisation');
        }
    });
}

export function updateAddEngrav(productData, productContainer) {
    personalisationInit(productData, productContainer, 'engrav');
}

export function updateAddEmboss(productData, productContainer) {
    personalisationInit(productData, productContainer, 'emboss');
}

export function updateBraceletAdjustment(productData, productContainer) {
    personalisationInit(productData, productContainer, 'bracelet-adjustment');
}

export function setupConfirmEngravAddToCart() {
    subscribe('addPersonalisationEngraving:success', data => handleCartAdd(data.formEl, data.formData));
}

export function setupConfirmEmbossAddToCart() {
    subscribe('addPersonalisationEmbossing:success', data => handleCartAdd(data.formEl, data.formData));
}

export function setupConfirmBraceletAdjustmentAddToCart() {
    subscribe('addPersonalisationBraceletAdjustment:success', data => handleCartAdd(data.formEl, data.formData));
}

export function updateEngvPreview() {
    document.addEventListener('change', function(e) {
        let previewWrapper = document.querySelectorAll('.engrave--preview .preview-line');
        previewWrapper.forEach(previewElem => {
            if (previewElem && (e.target && e.target.name == 'dwfrm_productpersonalisation_emboss_embossingMessageFont')) {
                if (e.target.value == 'Cursive' || e.target.value == 'CELESTE') {
                    previewElem.classList.add('font-family--cursive');
                    previewElem.classList.remove('text-transform--uppercase');
                } else if (e.target.value == 'Italic') {
                    previewElem.classList.remove('text-transform--uppercase');
                    previewElem.classList.add('font-style--italic');
                } else {
                    previewElem.classList.add('text-transform--uppercase');
                    previewElem.classList.remove('font-family--cursive');
                    previewElem.classList.remove('font-style--italic');
                }
            }
            if (previewElem && (e.target && e.target.name == 'dwfrm_productpersonalisation_engrav_engravMessageFont')) {
                if (e.target.value == 'Cursive' || e.target.value == 'CELESTE') {
                    previewElem.classList.add('font-family--cursive');
                } else if (e.target.value == 'Italic') {
                    previewElem.classList.add('font-style--italic');
                } else {
                    previewElem.classList.remove('font-family--cursive');
                    previewElem.classList.remove('font-style--italic');
                }
            }
        });
    });
    document.addEventListener('input', function(e) {
        var engravePreview = document.querySelector('[data-personalization-preview-line1]');
        var engravePreview1 = document.querySelector('[data-personalization-preview-line2]');
        let embossDotRadio = document.querySelectorAll('[data-emboss-dot]'),
            isWithoutDot;

        if (engravePreview != null) {
            if (engravePreview && e.target && e.target.hasAttribute('data-engrave-msg')) {
                engravePreview.textContent = e.target.value;
            }
        }

        if (engravePreview1 != null) {
            if (engravePreview1 && e.target && e.target.hasAttribute('data-engrave-msg1')) {
                engravePreview1.textContent = e.target.value;
            }
        }

        if (embossDotRadio != null) {
            if (embossDotRadio[0] && embossDotRadio[0].checked) {
                isWithoutDot = false;
            } else {
                isWithoutDot = true;
            }
        }
        if (engravePreview != null && isWithoutDot != null) {
            if (engravePreview && e.target && e.target.hasAttribute('data-emboss-msg')) {
                let embossValue = e.target.value;
                if (embossValue.length > 1 && !isWithoutDot) {
                    let embossDot = embossValue.split('').join('.');
                    engravePreview.textContent = embossDot;
                } else if (embossValue.length == 0 && !isWithoutDot) {
                    engravePreview.textContent = '';
                } else if (embossValue.length == 1 || isWithoutDot) {
                    engravePreview.textContent = embossValue;
                }
            }
        }
    });

    document.addEventListener('change', function(e) {
        let embossDot = document.querySelector('[data-emboss-dots]');
        if (embossDot != null) {
            if (embossDot) {
                embossDot.value = e.target.checked ? 'true' : 'false';
            }
        }
        var embossInp = document.querySelector('[data-emboss-msg]');
        let previewWrapper = document.querySelector('.engrave--preview .preview-line');
        if (embossInp != null && previewWrapper && previewWrapper != null && e.target) {
            if (e.target.type == 'checkbox' && e.target.checked && e.target.hasAttribute('data-emboss-dots') && embossDot && embossDot.value == 'true') {
                previewWrapper.textContent = embossInp.value.split('').join('.');
            } else if (e.target.hasAttribute('data-emboss-dots') && embossDot && embossDot.value == 'false') {
                previewWrapper.textContent = embossInp.value;
            }
        }
    });

    document.addEventListener('change', function(e) {
        let engravEmbossClass = document.querySelector('.personalisation__cta-save');
        let engravEmbossCheckbox = document.querySelector('[data-engrav-emboss-checkbox]');
        if (engravEmbossCheckbox != null) {
            engravEmbossCheckbox.value = e.target.checked ? 'true' : 'false';
        }
        if (engravEmbossCheckbox != null && engravEmbossClass != null && e.target) {
            if (e.target.type == 'checkbox' && e.target.checked && e.target.hasAttribute('data-engrav-emboss-checkbox') && engravEmbossCheckbox.value == 'true') {
                engravEmbossClass.removeAttribute('disabled');
            } else if (e.target.hasAttribute('data-engrav-emboss-checkbox') && engravEmbossCheckbox.value == 'false') {
                engravEmbossClass.setAttribute('disabled', 'disabled');
            }
        }
    });

}
function isVariationSelected(sizeAttr) {
    let flag = false;
    Object.values(sizeAttr).forEach(function(option) {
        if (option && option.selected && (option.getAttribute('data-attr-value') !== null && option.getAttribute('data-attr-value') !== '')) {
            flag = true;
        }
    });
    return flag;
}
function removePDPHidden() {
    $('.item-info__container').each(function() {
        if ($(this).hasClass('hidden')) {
            $(this).removeClass('hidden');
        }
    });
}
export function loadPreview() {
    let embossDot = document.querySelector('[data-emboss-dots]');
    var embossInp = document.querySelector('[data-emboss-msg]');
    let previewWrapper = document.querySelector('.engrave--preview .preview-line');
    var embossFontType = document.querySelectorAll('[data-emboss-font-type]');
    if (embossInp != null && previewWrapper && previewWrapper != null) {
        if (embossDot && embossDot.checked == true) {
            previewWrapper.textContent = embossInp.value.split('').join('.');
        } else if (embossDot && embossDot.checked == false) {
            previewWrapper.textContent = embossInp.value;
        }
    }
    if (previewWrapper && (embossFontType[0].name == 'dwfrm_productpersonalisation_emboss_embossingMessageFont' || embossFontType[0].name == 'dwfrm_productpersonalisation_engrav_engravMessageFont')) {
        let checkedFontType;
        [].forEach.call(embossFontType, currentItem => {
            if (currentItem.checked) {
                checkedFontType = currentItem.value;
            }
        });
        if (checkedFontType == 'Cursive' || checkedFontType == 'CELESTE') {
            previewWrapper.classList.add('font-family--cursive');
            previewWrapper.classList.remove('text-transform--uppercase');
        } else if (checkedFontType == 'Italic') {
            previewWrapper.classList.remove('text-transform--uppercase');
            previewWrapper.classList.add('font-style--italic');
        } else {
            previewWrapper.classList.add('text-transform--uppercase');
            previewWrapper.classList.remove('font-family--cursive');
            previewWrapper.classList.remove('font-style--italic');
        }
    }
}

export var personalisationModal = {
    backToPDPEle: '[data-back-to-product="back-to-product"]',
    strapChooseColorSaveBtn: document.querySelector('[data-product-choose-color-save]'),
    strapAddStrapSaveBtn: document.querySelector('[data-product-strap-add-save]'),
    saveBtnSelector: '[data-product-personalisation="save"]',


    triggerBackToPdp: function() {
        $(this.backToPDPEle).trigger('click');
    },

    sendMessageTo3DWidget: function(widget3DParams) {
        let iFrame = document.querySelector('[data-id="3DWidget"]');

        if (iFrame && widget3DParams) {
            try {
                let content = iFrame.contentWindow;
                widget3DParams.forEach(function(message) {
                    content.postMessage(JSON.stringify(message), '*');
                });
            } catch {
                return false;
            }
        }
    },

    showModal: function(_currentEleClass) {
        let bodyEle = document.querySelector('body'),
            allPersonalisationElement = document.querySelectorAll('.item-info__personalization-container'),
            currentPersonalisationElement = document.querySelector('.' + _currentEleClass),
            allTriggerElement = document.querySelectorAll('[data-trigger-vas]');

        window.scroll({top: 0, behavior: 'smooth'});
        $('html, body').animate({
            scrollTop: $('.pdp-main').offset().top
        }, 500);

        [].forEach.call(allPersonalisationElement, function(currentEle) {
            currentEle.classList.add('hidden');
        });

        bodyEle.classList.add('personalization-mode-on');
        currentPersonalisationElement.classList.remove('hidden');

        let allCloseButtons = document.querySelectorAll('.personalisation__cta-close'),
            strapAddStrapSaveBtn = document.querySelector('[data-product-strap-add-save]'),
            modalObj = this;

        [].forEach.call(allCloseButtons, function(currentBtn) {
            currentBtn.addEventListener('click', function(event) {
                event.preventDefault();
                modalObj.hideModal();
            })
        });

        if (modalObj.strapChooseColorSaveBtn != null) {
            modalObj.changeSavedStatus(modalObj.strapChooseColorSaveBtn);
            $(modalObj.strapChooseColorSaveBtn).off().on('click', function(e) {
                e.preventDefault();
                modalObj.saveStrapColor(this);
            });
        }

        let productContainer = getProductContainer($('[data-product-personalisation="descContainerStrapColor"]'));
        $(productContainer).find('a[data-static-option-id]').off().on('click', function() {
            modalObj.changeSavedStatus(modalObj.strapChooseColorSaveBtn);
        });

        $('[data-add-strap-color]').off().on('click', function() {
            modalObj.changeSavedStatus(modalObj.strapChooseColorSaveBtn);
        });

        if (strapAddStrapSaveBtn != null) {
            strapAddStrapSaveBtn.addEventListener('click', function(event) {
                event.preventDefault();
                modalObj.changeSavedStatus(this, true);
            });
        }

        [].forEach.call(allTriggerElement, function(currentEl) {
            $(currentEl).off().on('click', function(e) {
                e.preventDefault();
                modalObj.hideModal();
                $('[data-product-component="' + currentEl.dataset.triggerVas + '"]').trigger('click');
            })
        });

        if (_currentEleClass === 'product-strap-choose-color') {
            let screenWidth = window.innerWidth;

            if (screenWidth > 1024) {
                $('#productStrapChooseColorSlider, .product-strap-add__product-tilelist').slick('unslick');
            }
        }

        if ($('.slick-slider')) {
            $('.slick-slider').slick('setDimensions');
        }
    },

    hideModal: function() {
        let bodyEle = document.querySelector('body');
        bodyEle.classList.remove('personalization-mode-on');

        if ($('.slick-slider')) {
            $('.slick-slider').slick('setDimensions');
        }

        window.scroll({top: 0, behavior: 'smooth'});
    },

    updateStrapStatus: function(isStrapUnvailable, isStrapFor) {
        let addEngravingBtn = document.querySelector('.trigger-add_engraving');
        let addEmbossinBtn = document.querySelector('.trigger-add_embossing');
        let showBraceletAdjustmentBtn = document.querySelector('.trigger-show_bracelet_adjustment');
        let strapChooseColorSaveBtn = this.strapChooseColorSaveBtn,
            strapAddStrapSaveBtn = this.strapAddStrapSaveBtn;

        if (isStrapUnvailable) {
            if (addEngravingBtn) {
                addEngravingBtn.disabled = true;
            }
            if (addEmbossinBtn) {
                addEmbossinBtn.disabled = true;
            }
            if (showBraceletAdjustmentBtn) {
                showBraceletAdjustmentBtn.disabled = true;
            }

            if (isStrapFor === 'forChooseColor' && strapChooseColorSaveBtn) {
                strapChooseColorSaveBtn.disabled = true;
            }

            if (isStrapFor === 'forAddStrap' && strapAddStrapSaveBtn && (strapAddStrapSaveBtn.dataset.countOn && parseInt(strapAddStrapSaveBtn.dataset.countOn) == 0)) {
                strapAddStrapSaveBtn.disabled = true;
            }

            let strapStatusMessageEle = document.querySelector('[data-status-message="product-strap-status-message"]'),
                strapStatusMessageCurrent = $(strapStatusMessageEle).find('.status-message--unavailable').html();

            dialog.open({
                html: strapStatusMessageCurrent,
                type: 'html',
                options: {
                    modalID: 'productStrapStatus',
                    modalName: 'productStrapStatus',
                    modalClass: 'modal--product-strap-status',
                    overlayOthers: true,
                    keepAlive: true
                }
            });
        } else if (strapChooseColorSaveBtn) {
            if (addEngravingBtn) {
                addEngravingBtn.disabled = false;
            }
            if (addEmbossinBtn) {
                addEmbossinBtn.disabled = false;
            }
            if (showBraceletAdjustmentBtn) {
                showBraceletAdjustmentBtn.disabled = false;
            }
            if (isStrapFor === 'forChooseColor' && strapAddStrapSaveBtn) {
                strapChooseColorSaveBtn.disabled = false;
            }
            if (isStrapFor === 'forAddStrap' && strapAddStrapSaveBtn) {
                strapAddStrapSaveBtn.disabled = false;
            }
            if (isStrapFor === 'forAddStrap' && strapAddStrapSaveBtn && strapAddStrapSaveBtn.dataset.countOn == 0) {
                strapAddStrapSaveBtn.disabled = true;
            }
        }
    },

    initSaveDataBtn: function() {
        let saveButton = document.querySelector(this.saveBtnSelector),
            modalObj = this;

        modalObj.changeSavedStatus(saveButton);

        $(saveButton).off().on('click', function(e) {
            e.preventDefault();

            var form = $(this).parents('form'),
                serializedData = form.serialize();

            if (!validateForm(form[0])) {
                return false;
            }

            if ($(this).data('product-add-to-bag') == true) {
                handleCartAdd(this, getQueryStringParams(serializedData), null);
            } else {
                modalObj.changeSavedStatus(this, true);
            }

            modalObj.updateVASData(serializedData);

            if ($(this).data('close-modal') == true) {
                modalObj.triggerBackToPdp();
            }
        });
    },

    initPersonaliseStrapBtn: function(pdpMain, el) {
        let personaliseStrap = document.querySelector('[data-trigger-vas="product-strap-choose-color"]'),
            modalObj = this;

        if (personaliseStrap) {
            personaliseStrap.addEventListener('click', function() {
                let currentEleClass = this.getAttribute('data-trigger-vas');
                pdpMain.classList.remove('opacity');
                el.classList.remove('opacity');
                el.classList.remove('engrave-content__animation');
                removePDPHidden();
                modalObj.showModal(currentEleClass);
            })
        }
    },

    saveDataToUrl: function(serializedData) {

        if (!serializedData) {
            return false;
        }

        let pageUrl = window.location.href.split('?')[0],
            vasData = {},
            formDataArray = serializedData ? serializedData.split('&') : [],
            urlParamsObj = getQueryStringParams(window.location.search, null),
            po = urlParamsObj.po ? urlParamsObj.po.split(',') : [],
            selectedFitName;

        formDataArray.forEach(function(data) {
            let paramAndvalue = data.split('='),
                fieldName = paramAndvalue && paramAndvalue[0] ? paramAndvalue[0] : '',
                fieldValue = paramAndvalue && paramAndvalue[1] ? paramAndvalue[1] : '';

            if (fieldName) {
                if (urlParamsObj[fieldName]) {
                    delete urlParamsObj[fieldName];
                }

                let fieldNameArray = fieldName.split('_'),
                    key = fieldNameArray ? fieldNameArray.pop() : '';

                if (key) {
                    vasData[key] = decodeURIComponent(fieldValue);
                }
            }
        });

        if (vasData.po && po.indexOf(vasData.po) < 0) {
            po.push(vasData.po);
        }

        vasData.po = po.join(',');

        if (vasData.hasBraceletAdjustment === 'true' && vasData.braceletAdjustmentFit && vasData.pid) {
            selectedFitName = $('#dwfrm_productpersonalisation_braceletAdjustment_braceletAdjustmentFit-' + vasData.braceletAdjustmentFit + '-' + vasData.pid);
            selectedFitName = selectedFitName.length > 0 && selectedFitName[0].labels && selectedFitName[0].labels.length > 0 ? selectedFitName[0].labels[0].innerText : '';
            vasData.selectedFitName = selectedFitName ? selectedFitName : '';
        }
        urlParamsObj = Object.assign(urlParamsObj, vasData);

        let vasUrl = appendParamsToURL(window.location.pathname, urlParamsObj);
        updateHistoryState(pageUrl, vasUrl);
    },

    updateVASData: function(serializedData) {
        this.saveDataToUrl(serializedData);

        this.modifyVASBtnsDesc();
        initShareLink();
    },

    initVasFieldChange: function(el) {
        let inputEle = $(el).find('input'),
            saveButton = $(el).find(this.saveBtnSelector),
            modalObj = this;

        $(inputEle).off().on('change keyup paste', function() {
            modalObj.changeSavedStatus(saveButton);
        });
    },

    changeSavedStatus: function(button, showSuccessMsg) {
        let dataButtonText = $(button).find('[data-button-text]'),
            dataButtonSavedText = $(button).find('[data-button-saved-text]');

        if (showSuccessMsg && showSuccessMsg === true) {
            $(dataButtonText).addClass('hidden');
            $(dataButtonSavedText).removeClass('hidden');
        } else {
            $(dataButtonText).removeClass('hidden');
            $(dataButtonSavedText).addClass('hidden');
        }
    },

    saveStrapColor: function(button) {
        let strapName = $('[data-strap-chooser]').find('.pdp-straps__item');
        if (strapName && strapName != null) {
            $(strapName).each(function() {
                if ($(this).hasClass('selectedStrapOption')) {
                    $(this).removeClass('selectedStrapOption');
                }
                if ($(this).hasClass('plpSlectedStrap')) {
                    $(this).removeClass('plpSlectedStrap');
                }
            })
        }

        let selectedStrapEle = $('[data-strap-chooser]').find('.pdp-straps__item.toggle--active');

        if (!selectedStrapEle) {
            return false;
        }

        let strapUrl = $(selectedStrapEle).attr('href'),
            strapUrlArray = strapUrl ? strapUrl.split('?') : [],
            serializedData = strapUrlArray && strapUrlArray[1] ? strapUrlArray[1] : '';

        this.updateVASData(serializedData);
        $(selectedStrapEle).addClass('selectedStrapOption');
        chooseColorBackToPdp();
        this.changeSavedStatus(button, true);

        if ($(button).data('close-modal') == true) {
            this.hideModal();
        }
    },

    initBraceletAdjustmentBtn: function() {
        var params = {
            'triggerEle': document.querySelector('[data-product-component="show-bracelet-adjustment-form"]'),
            'containerEleClass': 'braceletAdjust-template--load',
            'element': 'data-braceletadjustment',
            'pdpMain': 'data-main-component'
        };

        this.bindOpenTrigger(params);
    },

    initStrapColorBtn: function() {
        let allButtons = document.querySelectorAll('[data-personalization-element="product-strap-choose-color"]'),
            modalObj = this;

        [].forEach.call(allButtons, function(currentBtn) {
            currentBtn.addEventListener('click', function() {
                let currentEleClass = this.getAttribute('data-personalization-element');
                modalObj.showModal(currentEleClass);
            })
        });
    },

    initAddStrapBtn: function() {
        let allButtons = document.querySelectorAll('[data-personalization-element="product-strap-add"]'),
            allAddStrapRadioBtn = document.querySelectorAll('[data-strap-element="product-strap-add-radio-btn"]'),
            modalObj = this;

        [].forEach.call(allButtons, function(currentBtn) {
            currentBtn.addEventListener('click', function() {
                let currentEleClass = this.getAttribute('data-personalization-element'),
                    selectedAddStrapCount = parseInt($('[data-product-personalisation="VASDescAddStrap"]').text()),
                    radioGroup = $( 'input[name^="additionalStrapCheckbox-"]' );

                if (selectedAddStrapCount <= 0) {
                    radioGroup.forEach(function(radio) {
                        $(radio).prop('checked', false);
                        $(radio).attr('data-product-checked', 'false');
                    });
                }
                modalObj.showModal(currentEleClass);
            })
        });
        [].forEach.call(allAddStrapRadioBtn, function(currentBtn) {
            currentBtn.addEventListener('click', function() {
                var isStrapUnvailable = JSON.parse( $(this).parent().attr('data-strap-instock') );
                personalisationModal.updateStrapStatus(!isStrapUnvailable, 'forAddStrap');
            })
        });
    },

    intHowToChangeStrap: function() {
        if ($('.strap-how-to-change-link').length > 0) {
            $('.strap-how-to-change-link').click(function(e) {
                e.stopPropagation();
                e.preventDefault();
                var url = $(this).attr('data-url').split('?');
                window.open(url, '_blank');
            });
        }
    },

    initEmbossBtn: function() {
        let embossObj = this;
        var params = {
            'triggerEle': document.querySelector('[data-product-component="show-emboss-form"]'),
            'containerEleClass': 'emboss-template--load',
            'element': 'data-emboss',
            'callBack': function() {
                embossObj.triggerEmbossDotsInput();
            }
        };
        this.triggerEmbossDotsInput();
        this.bindOpenTrigger(params);
    },

    initEngravBtn: function() {
        var params = {
            'triggerEle': document.querySelector('[data-product-component="show-engrav-form"]'),
            'containerEleClass': 'engrave-template--load',
            'element': 'data-engrave',
            'callBack': this.initEngravAddLine
        };

        this.bindOpenTrigger(params);
    },

    initSwitchModal: function(modalContainer) {
        [].forEach.call(modalContainer.querySelectorAll('[data-switch-modal]'), function(currentEl) {
            $(currentEl).off().on('click', function() {
                $('[data-product-component="' + $(this).data('switch-modal') + '"]').trigger('click');
            });
        });
    },

    initEngravAddLine: function(el) {
        var addline = $(el.querySelector('[data-add-engrav-line2]')),
            engravLine2Container = $(el.querySelector('[data-engrav-line2]')),
            engravLine2 = $(el.querySelector('[data-engrave-msg="line-two"]'));

        if (engravLine2 && engravLine2.val()) {
            addline.addClass('hidden');
            engravLine2Container.removeClass('hidden');
        } else if (addline) {
            addline.off().on('click', function() {
                engravLine2Container.removeClass('hidden');
                $(this).addClass('hidden');
            });
        }
    },

    triggerEmbossDotsInput: function() {
        $('.checkEmboss__Dots').on('change', function() {
            if ($(this).is(':checked')) {
                $(this).next('input').val('true');
            } else {
                $(this).next('input').val('false');
            }
        });
    },

    bindOpenTrigger: function(params) {
        if (!params.triggerEle || params.triggerEle == null || $(params.triggerEle).hasClass('disable--personalisation')) {
            return false;
        }
        let modalObj = this;
        $(params.triggerEle).off().on('click', function(e) {
            if (e.target.matches('.removeButton')) {
                return false;
            } else {
                let addRefillButton = document.querySelector('.product-addrefill__button');
                if (addRefillButton && addRefillButton.getAttribute('data-pid') != '') {
                    var refillContainer = document.querySelector('[data-product-component="selected-refills"]');
                    if (refillContainer && (refillContainer.firstElementChild == null || (refillContainer.firstElementChild && refillContainer.firstElementChild.getAttribute('data-sel-refillid') == ''))) {
                        return false;
                    }
                }
                params.check3d = this.getAttribute('data-disableconfig');
                e.preventDefault();
                $.ajax({
                    url: this.getAttribute('data-url'),
                    type: 'get',
                    success: function(response) {
                        modalObj.loadTemplate(response, params);
                    }
                });
            }
        });
    },

    loadTemplate: function(templateData, params) {
        if (!templateData) {
            return false;
        }
        $('[data-personalisation-template-loader]').removeAttr('class').addClass(params.containerEleClass).html(templateData);

        if (!params.check3d) {
            widget3DConfiguration();
        }

        window.scroll({top: 0, behavior: 'smooth'});
        $('html, body').animate({
            scrollTop: $('.pdp-main').offset().top
        }, 500);

        if (!params.pdpMain) {
            params.pdpMain = 'data-strap-color';
        }

        if (!params.selectAttr) {
            params.selectAttr = '.pdp-main .item-info__personalization-container';
        }

        let el = document.querySelector('[' + params.element + ']'),
            pdpMain = document.querySelector('[' + params.pdpMain + ']'),
            allTriggerElement = document.querySelectorAll('[data-trigger-vas]'),
            selectAttr = $(params.selectAttr);

        pdpMain.classList.add('opacity');
        el.classList.add('opacity');
        el.classList.add('engrave-content__animation');

        if ($(selectAttr).hasClass('opacity')) {
            $('.product-gallery--pdp').addClass('opacity');
            $('.pdp').addClass('opacity');
            $('.pdp-main__breadcrumbs').addClass('opacity');
            $('.pdp-main__media').addClass('galleryAnimation');
        } else {
            $('.product-gallery--pdp').removeClass('opacity');
            $('.pdp').removeClass('opacity');
            $('.pdp-main__breadcrumbs').removeClass('opacity');
            $('.pdp-main__media').removeClass('galleryAnimation');
        }

        if (document.querySelector('[data-product-personalisation="form"]')) {
            setupAJAXForm(document.querySelector('[data-product-personalisation="form"]'));
        }

        this.initSaveDataBtn();
        this.fetchUrlParamsToForm(params.containerEleClass);
        this.initPersonaliseStrapBtn(pdpMain, el);
        this.initVasFieldChange(el);
        this.backToPDP(el);
        modules.tracking.init();
        this.initSwitchModal(el);

        if (typeof params.callBack == 'function') {
            params.callBack(el);
        }

        [].forEach.call(allTriggerElement, function(currentElem) {
            $(currentElem).off().on('click', function() {
                $('[data-product-component="' + currentElem.dataset.triggerVas + '"]').trigger('click');
            })
        });

        loadPreview();
    },

    backToPDP: function(getAttr) {
        let backToPDPEle = document.querySelector(this.backToPDPEle);

        if (!backToPDPEle || backToPDPEle == null) {
            return false;
        }

        backToPDPEle.addEventListener('click', function() {
            $('html, body').animate({
                scrollTop: $('.pdp-main').offset().top
            }, 1000);

            let el = getAttr,
                pdpMain = document.querySelector('[data-main-component]'),
                selectAttr = $('.pdp-main .item-info__personalization-container');

            pdpMain.classList.remove('opacity');
            el.classList.remove('opacity');
            el.classList.remove('braceletadjustment-content__animation');
            el.classList.remove('emboss-content__animation');
            el.classList.remove('engrave-content__animation');

            if ($(selectAttr).hasClass('opacity')) {
                $('.product-gallery--pdp').addClass('opacity');
                $('.pdp').addClass('opacity');
                $('.pdp-main__breadcrumbs').addClass('opacity');
                $('.pdp-main__media').addClass('galleryAnimation');
            } else {
                $('.product-gallery--pdp').removeClass('opacity');
                $('.pdp').removeClass('opacity');
                $('.pdp-main__breadcrumbs').removeClass('opacity');
                $('.pdp-main__media').removeClass('galleryAnimation');
                $('.braceletAdjust-template--load').empty();
            }
            removePDPHidden();
        });
    },

    // code for fetching parameters from url
    fetchUrlParamsToForm: function(containerEleClass) {
        var urlParams = window.location.search,
            queryStringParams = getQueryStringParams(urlParams, null),
            containerEle = $('.' + containerEleClass),
            skipFields = [ 'po' ];

        for (let i in queryStringParams) {
            let field = containerEle.find('[name$="' + i + '"]');

            if (field && field.length > 0) {
                let value = queryStringParams[i];
                if (field.attr('type') == 'radio') {
                    if (value) {
                        field = containerEle.find('[value="' + value + '"]');
                        field.prop('checked', true);
                    }
                } else if (field.attr('type') == 'checkbox') {
                    if (value && value != 'false') {
                        field.prop('checked', true);
                    } else {
                        field.prop('checked', false);
                    }
                } else if (skipFields.indexOf(i) == -1) {
                    field.val(value);
                }
            }
        }
    },

    removePersonalisedData: function(e) {
        if (e.data) {
            e.preventDefault();
            e.stopImmediatePropagation();
            let strapName = $('[data-strap-chooser]').find('.pdp-straps__item');
            if (strapName && strapName != null) {
                $(strapName).each(function() {
                    if ($(this).hasClass('selectedStrapOption')) {
                        $(this).removeClass('selectedStrapOption');
                    }
                    if ($(this).hasClass('plpSlectedStrap')) {
                        $(this).removeClass('plpSlectedStrap');
                    }
                })
            }
            chooseColorBackToPdp();
        }

        let container = e.container || e.data.container,
            removeParamNameArray = e.removeParamNameArray || e.data.removeParamNameArray || [],
            pageUrl = window.location.pathname,
            paramObj = e.paramObj || e.data.paramObj,
            po = paramObj.po ? paramObj.po.split(',') : [],
            widget3DParams = e.data ? e.data.widget3DParams : null,
            modalObj = e.data ? e.data.modalObj : this,
            callBack = e.data ? e.data.callBack : null;

        if (paramObj.po && po.indexOf(removeParamNameArray[0]) > -1) {
            po.splice(po.indexOf(removeParamNameArray[0]), 1);
            paramObj.po = po.join(',');

            if (po.length <= 0) {
                removeParamNameArray.push('po');
            }
        }

        for (let i in removeParamNameArray) {
            delete paramObj[removeParamNameArray[i]];
        }

        if (widget3DParams) {
            modalObj.sendMessageTo3DWidget(widget3DParams);
        }

        pageUrl = appendParamsToURL(pageUrl, paramObj);
        updateHistoryState(false, pageUrl);
        let textNone = container.find('[data-product-personalisation^="VASDesc"]').attr('data-message-none');
        container.parents('[data-product-personalisation^="VASBtn"]').removeClass('vasTextButton');
        container.find('[data-product-personalisation^="VASDesc"]').removeClass('uppercase').text(textNone);
        container.find('[data-product-personalisation^="remove"]').off('click').addClass('hidden');

        if (typeof callBack == 'function') {
            callBack(e);
        }
    },

    initRemoveBtn: function(container, paramObj, removeParamNameArray, widget3DParams, callBack) {
        let removeBtn = container.find('[data-product-personalisation="remove"]'),
            modalObj = this;

        if (removeBtn != null) {
            removeBtn.removeClass('hidden').off('click');
            $(removeBtn).off().on('click', {container: container, paramObj: paramObj, removeParamNameArray: removeParamNameArray, widget3DParams: widget3DParams, modalObj: modalObj, callBack: callBack}, this.removePersonalisedData);
        }
    },

    changeEmbossPdpBtnDesc: function(paramObj) {
        let VASDescContainerEmboss = $('[data-product-personalisation="VASDescContainerEmboss"]'),
            removeParamNameArray = [ 'emboss', 'hasEmbossing', 'font-type-hidden', 'embossingMessageFont', 'embossingHasFoil', 'embossLine1', 'embossingHasDots', 'noReturnPolicyAcknowledged' ],
            widget3DParams = [ {embossingMsg_1: ''}, {embossingFont: ''}, {embossingColor: ''}, {view: 'DEFAULT'} ];

        if (!VASDescContainerEmboss.length || !paramObj || !paramObj.hasEmbossing || paramObj.hasEmbossing == 'false') {
            this.removePersonalisedData({container: VASDescContainerEmboss, paramObj: paramObj, removeParamNameArray: removeParamNameArray});
            return false;
        }

        let pdpEmbossBtn = $('[data-product-personalisation="VASBtnEmboss"]'),
            pdpEmbossDescEle = $('[data-product-personalisation="VASDescEmboss"]'),
            embossLine1 = paramObj && paramObj.embossLine1 ? paramObj.embossLine1 : '',
            embossingHasDots = paramObj && paramObj.embossingHasDots ? paramObj.embossingHasDots : '';

        if (embossLine1) {
            pdpEmbossBtn.addClass('vasTextButton');

            if (embossingHasDots == 'true') {
                embossLine1 = embossLine1.split('').join('.');
            }

            let embossDesc = embossLine1;

            pdpEmbossDescEle.text(embossDesc).addClass('uppercase');

            this.initRemoveBtn(VASDescContainerEmboss, paramObj, removeParamNameArray, widget3DParams);
        } else {
            this.removePersonalisedData({container: VASDescContainerEmboss, paramObj: paramObj, removeParamNameArray: removeParamNameArray});
        }
    },

    unSelectStrapColor: function(params) {
        let container = params && params.data ? params.data.container : params.container;

        if (container) {
            let productContainer = getProductContainer(container);
            $(productContainer).find('a[data-static-option-id].toggle--active').removeClass('toggle--active');
        }
    },

    changeStrapColorBtnDesc: function(paramObj) {
        let descContainerStrapColor = $('[data-product-personalisation="descContainerStrapColor"]'),
            removeParamNameArray = [ 'strapOption', 'strapColorName' ],
            removeBtn = $(descContainerStrapColor).find('[data-product-personalisation="remove"]'),
            strapId = removeBtn && removeBtn[0] ? removeBtn.data('default-strap-id') : '',
            widget3DParams = [ {strapId: strapId} ];

        if (!descContainerStrapColor.length || !paramObj || !paramObj.strapOption) {
            this.removePersonalisedData({container: descContainerStrapColor, paramObj: paramObj, removeParamNameArray: removeParamNameArray});
            return false;
        }

        let pdpDescStrapColorEle = $('[data-product-personalisation="VASDescStrapColor"]'),
            strapColorName = paramObj && paramObj.strapColorName ? paramObj.strapColorName : '';

        if (strapColorName) {
            pdpDescStrapColorEle.text(strapColorName);
            this.initRemoveBtn(descContainerStrapColor, paramObj, removeParamNameArray, widget3DParams, this.unSelectStrapColor);
        } else {
            this.removePersonalisedData({container: descContainerStrapColor, paramObj: paramObj, removeParamNameArray: removeParamNameArray});
        }
    },

    changeEngravePdpBtnDesc: function(paramObj) {
        let VASDescContainerEngrav = $('[data-product-personalisation="VASDescContainerEngrav"]'),
            removeParamNameArray = [ 'engrav', 'hasEngrav', 'engravLine1', 'engravLine2', 'engravMessageFont', 'noReturnPolicyAcknowledged' ],
            widget3DParams = [ {engravingMsg_1: ''}, {engravingMsg_2: ''}, {view: 'DEFAULT'} ];

        if (!VASDescContainerEngrav.length || !paramObj || !paramObj.hasEngrav || paramObj.hasEngrav == 'false') {
            this.removePersonalisedData({container: VASDescContainerEngrav, paramObj: paramObj, removeParamNameArray: removeParamNameArray});
            return false;
        }

        let pdpEngravBtn = $('[data-product-personalisation="VASBtnEngrav"]'),
            pdpEngravDescEle = $('[data-product-personalisation="VASDescEngrav"]'),
            engravLine1 = paramObj && paramObj.engravLine1 ? paramObj.engravLine1 : '',
            engravLine2 = paramObj && paramObj.engravLine2 ? paramObj.engravLine2 : '';

        if (engravLine1) {
            let engraveDesc = engravLine1;
            engraveDesc += engravLine2 ? ' | ' + engravLine2 : '';
            pdpEngravBtn.addClass('vasTextButton');
            pdpEngravDescEle.text(engraveDesc);
            this.initRemoveBtn(VASDescContainerEngrav, paramObj, removeParamNameArray, widget3DParams);
        } else {
            this.removePersonalisedData({container: VASDescContainerEngrav, paramObj: paramObj, removeParamNameArray: removeParamNameArray});
        }
    },

    changeBraceletAdjPdpBtnDesc: function(paramObj) {
        let VASDescContainerBraceletAdj = $('[data-product-personalisation="VASDescContainerBraceletAdj"]'),
            removeParamNameArray = [ 'braceletAdjustment', 'hasBraceletAdjustment', 'braceletAdjustmentWristSize', 'braceletAdjustmentFit' ];

        if (!VASDescContainerBraceletAdj.length || !paramObj || !paramObj.hasBraceletAdjustment || paramObj.hasBraceletAdjustment == 'false') {
            this.removePersonalisedData({container: VASDescContainerBraceletAdj, paramObj: paramObj, removeParamNameArray: removeParamNameArray});
            return false;
        }

        let pdpbraceletAdjBtn = $('[data-product-personalisation="VASBtnBraceletAdj"]'),
            pdpBraceletAdjDescEle = $('[data-product-personalisation="VASDescBraceletAdj"]'),
            braceletAdjustmentWristSize = paramObj && paramObj.braceletAdjustmentWristSize ? paramObj.braceletAdjustmentWristSize : '',
            braceletAdjustmentFit = paramObj && paramObj.braceletAdjustmentFit ? paramObj.braceletAdjustmentFit : '',
            adjDesc = braceletAdjustmentWristSize + ' ' + braceletAdjustmentFit,
            adjFitDisplay = paramObj.selectedFitName ? paramObj.selectedFitName : braceletAdjustmentFit;

        if (adjDesc) {
            pdpbraceletAdjBtn.addClass('vasTextButton');
            pdpBraceletAdjDescEle.text(adjFitDisplay).addClass('text-transform--capitalize');
            this.initRemoveBtn(VASDescContainerBraceletAdj, paramObj, removeParamNameArray);
        } else {
            this.removePersonalisedData({container: VASDescContainerBraceletAdj, paramObj: paramObj, removeParamNameArray: removeParamNameArray});
        }
    },

    modifyVASBtnsDesc: function() {
        let paramObj = getQueryStringParams(window.location.search, null);

        this.changeEngravePdpBtnDesc(paramObj);
        this.changeEmbossPdpBtnDesc(paramObj);
        this.changeBraceletAdjPdpBtnDesc(paramObj);
        this.changeStrapColorBtnDesc(paramObj);
    },

    initChooseColorBackToPdp: function() {
        let backToProductBtn = document.querySelector('[data-choose-color-back-to-product="back-to-product"]');

        if (backToProductBtn && backToProductBtn != null) {
            backToProductBtn.addEventListener('click', function() {
                chooseColorBackToPdp();
            });
        }
    },
    initRefillPersonalization: function() {
        let addRefillButton = document.querySelector('.product-addrefill__button');
        var VASBtnEmboss = document.querySelector('[data-product-personalisation="VASBtnEmboss"]');
        var VASBtnEngrav = document.querySelector('[data-product-personalisation="VASBtnEngrav"]');
        if (addRefillButton && addRefillButton.getAttribute('data-pid') != '') {
            $('.product-addrefill__button').css('opacity', '0.5');
            $('.product-attribute--engrav').css('opacity', '0.5');
            document.querySelector('.product-addrefill__button').addEventListener('mouseenter', function() {
                $('.product-addrefill__button').css('opacity', 1);
            });
            document.querySelector('.product-addrefill__button').addEventListener('mouseleave', function() {
                $('.product-addrefill__button').css('opacity', 0.5);
            });
            if (VASBtnEmboss) {
                VASBtnEmboss.addEventListener('mouseenter', function() {
                    $('.product-attribute--emboss').css('opacity', '1');
                    let disablePersonalisation = document.querySelector('.disable--personalisation');
                    let refillContainer = document.querySelector('[data-product-component="selected-refills"]');
                    let refillId = refillContainer && refillContainer.firstElementChild ? refillContainer.firstElementChild.getAttribute('data-sel-refillid') : '';
                    if (disablePersonalisation == null) {
                        if (!refillId) {
                            $('.value__emboss').css('display', 'none'); // Hide the engrave text
                            $('.value__emboss__select-refill').removeClass('hidden'); // Show the refill text
                            $('.personalisation__container').css('cursor', 'default');
                            $('.personalisation__arrow').css('cursor', 'default');
                        } else {
                            $('.value__emboss').css('display', 'block');
                            $('.value__emboss__select-refill').addClass('hidden');
                            $('.personalisation__container').css('cursor', 'pointer');
                        }
                    } else if (disablePersonalisation) {
                        let hideButton = document.querySelector('.hide-select-size');
                        let sizeAttr = document.querySelector('.product-attribute__size');
                        let isRefillSelected = false;
                        if (hideButton && sizeAttr) {
                            if (sizeAttr.getAttribute('data-selected-size') === null || sizeAttr.getAttribute('data-selected-size') === '') {
                                if (isVariationSelected(sizeAttr)) {
                                    isRefillSelected = true;
                                }
                            } else if ((sizeAttr.getAttribute('data-selected-size') !== null && sizeAttr.getAttribute('data-selected-size') !== '')) {
                                isRefillSelected = true;
                            }
                        } else if (hideButton == null && sizeAttr) {
                            if (isVariationSelected(sizeAttr)) {
                                isRefillSelected = true;
                            }
                        } else if (sizeAttr == null) {
                            isRefillSelected = true;
                        }
                        $('.value__emboss').css('display', 'block');
                        $('.value__emboss__select-refill').addClass('hidden');
                        $('.personalisation__container').css('cursor', 'pointer');

                        if (isRefillSelected && !refillId) {
                            $('.value__emboss').css('display', 'none');
                            $('.value__emboss__select-refill').removeClass('hidden');
                        }
                    }
                });
                VASBtnEmboss.addEventListener('mouseleave', function() {
                    if (addRefillButton) {
                        $('.product-attribute--emboss').css('opacity', '0.5');
                        let refillContainer = document.querySelector('[data-product-component="selected-refills"]');
                        let refillId = refillContainer && refillContainer.firstElementChild ? refillContainer.firstElementChild.getAttribute('data-sel-refillid') : '';
                        let variationAttr = document.querySelector('.product-attribute__size');
                        if (!refillId || (refillId && variationAttr && (variationAttr.getAttribute('data-selected-size') === null || variationAttr.getAttribute('data-selected-size') === ''))) {
                            $('.value__emboss').css('display', 'block'); // Show the engrave text
                            $('.value__emboss__select-refill').addClass('hidden'); // Hide the refill text
                            $('.personalisation__container').css('cursor', 'pointer');
                            if (!refillId) {
                                $('.product-addrefill__button').css('opacity', '0.5');
                            }
                        }
                    }
                });
            }
            if (VASBtnEngrav) {
                VASBtnEngrav.addEventListener('mouseenter', function() {
                    $('.product-attribute--engrav').css('opacity', '1');
                    let disablePersonalisation = document.querySelector('.disable--personalisation');
                    var refillContainer = document.querySelector('[data-product-component="selected-refills"]');
                    let refillId = refillContainer && refillContainer.firstElementChild ? refillContainer.firstElementChild.getAttribute('data-sel-refillid') : '';
                    if (disablePersonalisation == null) {
                        $('.personalisation__container').css('cursor', 'default');
                        if (!refillId) {
                            $('.value__engrave').css('display', 'none'); // Hide the engrave text
                            $('.value__select-refill').css('display', 'block'); // Show the refill text
                            $('.personalisation__arrow').css('cursor', 'default');
                        } else {
                            $('.value__engrave').css('display', 'block');
                            $('.value__select-refill').css('display', 'none');
                        }
                    } else if (disablePersonalisation) {
                        let hideButton = document.querySelector('.hide-select-size');
                        let sizeAttr = document.querySelector('.product-attribute__size');
                        let isRefillSelected = false;
                        if (hideButton && sizeAttr) {
                            if (sizeAttr.getAttribute('data-selected-size') === null || sizeAttr.getAttribute('data-selected-size') === '') {
                                if (isVariationSelected(sizeAttr)) {
                                    isRefillSelected = true;
                                }
                            } else if ((sizeAttr.getAttribute('data-selected-size') !== null && sizeAttr.getAttribute('data-selected-size') !== '')) {
                                isRefillSelected = true;
                            }
                        } else if (hideButton == null && sizeAttr) {
                            if (isVariationSelected(sizeAttr)) {
                                isRefillSelected = true;
                            }
                        } else if (sizeAttr == null) {
                            isRefillSelected = true;
                        }
                        $('.value__engrave').css('display', 'none');
                        $('.value__select-refill').css('display', 'none');
                        $('.personalisation__container').css('cursor', 'pointer');
                        if (isRefillSelected && !refillId) {
                            $('.value__select-refill').css('display', 'block');
                        } else if (isRefillSelected && refillId) {
                            $('.value__engrave').css('display', 'block');
                        }
                    }
                });
                VASBtnEngrav.addEventListener('mouseleave', function() {
                    if (addRefillButton) {
                        $('.product-attribute--engrav').css('opacity', '0.5');
                        let refillContainer = document.querySelector('[data-product-component="selected-refills"]');
                        let refillId = refillContainer && refillContainer.firstElementChild ? refillContainer.firstElementChild.getAttribute('data-sel-refillid') : '';
                        let variationAttr = document.querySelector('.product-attribute__size');
                        if (!refillId || (refillId && variationAttr && (variationAttr.getAttribute('data-selected-size') === null || variationAttr.getAttribute('data-selected-size') === ''))) {
                            $('.value__engrave').css('display', 'block'); // Show the engrave text
                            $('.value__select-refill').css('display', 'none'); // Hide the refill text
                            $('.personalisation__container').css('cursor', 'pointer');
                            if (!refillId) {
                                $('.product-addrefill__button').css('opacity', '0.5');
                            }
                        }
                    }
                });
            }
        } else {
            if (VASBtnEngrav) {
                VASBtnEngrav.addEventListener('mouseenter', function() {
                    let disablePersonalisation = document.querySelector('.disable--personalisation');
                    if (disablePersonalisation) {
                        $('.value__engrave').css('display', 'none');
                    } else {
                        $('.value__engrave').css('display', 'block');
                    }
                });
                VASBtnEngrav.addEventListener('mouseleave', function() {
                    $('.value__engrave').css('display', 'block');
                });
            }
            if (VASBtnEmboss) {
                VASBtnEmboss.addEventListener('mouseenter', function() {
                    let disablePersonalisation = document.querySelector('.disable--personalisation');
                    if (disablePersonalisation) {
                        $('.value__emboss').css('display', 'none');
                    } else {
                        $('.value__emboss').css('display', 'block');
                    }
                });
                VASBtnEmboss.addEventListener('mouseleave', function() {
                    $('.value__emboss').css('display', 'block');
                });
            }
        }
    },

    init: function() {
        this.initRefillPersonalization();
        this.updateVASData();
        this.initEngravBtn();
        this.initEmbossBtn();
        this.initBraceletAdjustmentBtn();
        this.initStrapColorBtn();
        this.initAddStrapBtn();
        this.initChooseColorBackToPdp();
        this.intHowToChangeStrap();
    }
}

export var personalisationModalInit = personalisationModal.init();
